// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.02 7.34V2.99C3.02 2.17 3.68 1.5 4.51 1.5H6.52C7.21 1.5 7.88 1.61 8.51 1.81C10.66 2.5 12.32 4.28 12.84 6.5C12.96 6.98 13.02 7.48 13.02 8V12.5C13.02 13.6 12.12 14.5 11.02 14.5H8.65M8.51 1.81V4.5C8.51 5.6 9.41 6.5 10.51 6.5H12.84',
  'M4 14L2 12L4 10M2 12H6',
];
